/**
 * Normalizes the configured GAINS environment value for downstream API usage.
 *
 * Rules:
 * - Defaults to `local` when no environment is provided.
 * - Converts the value to lowercase for consistency.
 * - Maps `preprod` to `prod` so pre-production deployments target production-labeled GAINS resources.
 *
 * @param environmentId Environment name from app configuration.
 * @returns Normalized GAINS environment name used in headers and request payloads.
 */
export function resolveGainsEnvironment(environmentId?: string): string {
  const environmentValue = (environmentId || 'local').toLowerCase();
  return environmentValue === 'preprod' ? 'prod' : environmentValue;
}
